import { useContext, useState } from "react";
import axios from 'axios';

import { useNavigate } from 'react-router-dom';

import ForgotPasswordForm from "../../components/Forms/ForgotPasswordForm/ForgotPasswordForm";

import useSetPageTitle from "../../hooks/useSetPageTitle";
import UserContext from "contexts/UserContext";

function ForgotPassword() {
    const { currentPromo } = useContext(UserContext);
    const navigate = useNavigate();

    useSetPageTitle('Esqueci minha senha', currentPromo);

    const [user, setUser] = useState('');
    const [emailWarning, setEmailWarning] = useState('');

    const [isSent, setIsSend] = useState(false);

    const [loading, setLoading] = useState(false);

    const trySubmitingEmail = (type) => {
        if (!user.length) {
            setEmailWarning('Este é um campo obrigatório');
            return;
        }
        setEmailWarning('');
        setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL}/client/forgot-password`, {
                user,
                type,
                promo_id: currentPromo.id
            })
            .then((response) => {
                setIsSend(true);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                setEmailWarning('Não foi possível recuperar sua senha, tente novamente mais tarde.');
            })
    }


    return(
        <div className="forgot-password-page-container">
                <ForgotPasswordForm
                user={user}
                setUser={setUser}
                emailWarning={emailWarning}
                nav={() => navigate(`/${currentPromo.path}/login`)}
                onClick={trySubmitingEmail}
                loading={loading}
                isSent={isSent}
            />
        </div>
    )
}

export default ForgotPassword;